// extracted by mini-css-extract-plugin
export default {"container":"WritableReviews_container__ACcm8","cardContainer":"WritableReviews_cardContainer__sksH4","noContents":"WritableReviews_noContents__oS5P4"};